import React, { Component } from 'react';
import { connect } from 'react-redux';
import CategoryBar from './CategoryBar.jsx';
import { navigate } from '../modules/high_level_actions';

class SearchView extends Component {

  constructor(props) {
    super(props);

  }

  render() {
    let nItemCount = '0';
    let aItems = '';

    if (this.props.searchResults) {
      if (this.props.searchResults.found > 0) {
        nItemCount = this.props.searchResults.found;
        aItems = this.props.searchResults.hit.map((oItem, i) => {
          if (this.props.searchResults.hit) {
            return (
              <li key={'SearchResult' + (oItem && oItem.fields ? oItem.fields.mmid : i)}>
                <a href={"/catalog/product/" + oItem.fields.id + '-' + oItem.fields.url} onClick={(evt) => this.props.dispatch(navigate(evt))}>
                  <img
                    className="product-scaled"
                    src={'//s3.amazonaws.com/bookspan-media/covers/full/' + oItem.fields.mmid + '.jpg'}
                  />
                </a>
              </li>
            );
          }
        });
      } else if (!this.props.searchLoading ) {
        aItems = <li>Sorry, no matches</li>
      }
    }

    return (
      <div className="content-max-width content-container">
        <CategoryBar />
        <div className="category-body">
          <div className="search-wrapper">
            <h1>Search Results</h1>
            <div className="bottom-line">
              <div className="half-col">
                <h4>{ this.props.searchLoading ? " Loading ... " : "Found " + nItemCount + " items for " + this.props.searchQuery + "."}</h4>
              </div>
            </div>
            <div className="product-list">
              <ul>
                {aItems}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
};



function mapStateToProps(state){
    return {
      'searchLoading': state.searchLoading,
      'searchResults': state.searchResults,
      'searchQuery': state.searchQuery
    };
}

export default connect(mapStateToProps)(SearchView);


// WEBPACK FOOTER //
// ./src/components/SearchView.jsx